import React, { lazy } from 'react'
import { FrontDeskType } from '../Common'

const BillingSchedule = lazy(() =>
  import('./BillingSchedule').then(module => ({
    default: module.BillingSchedule,
  }))
)

const RateAdjustmentAuditLog = lazy(() =>
  import('./RateAdjustmentAuditLog').then(module => ({
    default: module.RateAdjustmentAuditLog,
  }))
)

export const dueInBSPath = `/frontdesk/duein/detail/billingschedule`
export const inHouseBSPath = `/frontdesk/inhouse/detail/billingschedule`
export const dueOutBSPath = `/frontdesk/dueout/detail/billingschedule`

export const inHouseBSAuditLogPath = `/frontdesk/inhouse/detail/billingschedule/auditlog`

export const BillingScheduleRoutes = [
  {
    props: { exact: true, path: dueInBSPath },
    component: <BillingSchedule mode={FrontDeskType.DueIn} />,
  },

  {
    props: { exact: true, path: inHouseBSPath },
    component: <BillingSchedule mode={FrontDeskType.InHouse} />,
  },
  {
    props: { exact: true, path: dueOutBSPath },
    component: <BillingSchedule mode={FrontDeskType.DueOut} />,
  },

  {
    props: { exact: true, path: inHouseBSAuditLogPath },
    component: <RateAdjustmentAuditLog />,
  },
]
